import { I18n } from '@calendly/i18n'

import { useGetUserQuery } from 'common'

import AllScope from './all_scope'
import Item from './item'
import MenuGroup from './menu_group'
import Subtitle from './subtitle'

const PrimaryList = ({ selectItem, shouldRenderUsersAndTeams }) => {
  const { data } = useGetUserQuery()

  return (
    <MenuGroup>
      <Subtitle>{I18n.t('publisher.event_types.scope_dropdown.primary')}</Subtitle>
      <Item
        itemId="me"
        avatarLetter={data?.avatar_letter}
        avatarUrl={data?.avatar_url}
        onClick={() => selectItem('my_calendly')}
      >
        {I18n.t('publisher.title.my_calendly')}
      </Item>
      {shouldRenderUsersAndTeams && (
        <AllScope
          scope="all_users_and_teams"
          onClick={() => selectItem('all_users_and_teams')}
        />
      )}
    </MenuGroup>
  )
}

export default PrimaryList
